import { render, staticRenderFns } from "./AthleteSoccerBackground.vue?vue&type=template&id=401148c6&"
import script from "./AthleteSoccerBackground.vue?vue&type=script&lang=js&"
export * from "./AthleteSoccerBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports